import React from "react";
import theme from "app/theme";
import { store } from "app/state/store";
import Container from "@mui/material/Container";
import { HelmetProvider } from "react-helmet-async";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { PageLoader } from "app/components/pageLoader";
import { StoreProvider, useStoreRehydrated } from "easy-peasy";

interface ProviderProps {
  children?: any;
}

function Providers(props: ProviderProps) {
  return (
    <HelmetProvider>
      <StoreProvider store={store}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <AppContainer>{props.children}</AppContainer>
        </ThemeProvider>
      </StoreProvider>
    </HelmetProvider>
  );
}

export default Providers;

function AppContainer(props: ProviderProps) {
  const isRehydrated = useStoreRehydrated();
  if (!isRehydrated) {
    return <PageLoader />;
  }
  return (
    <Container maxWidth="lg" disableGutters>
      {props.children}
    </Container>
  );
}
